import CloseIcon from '@mui/icons-material/Close';
import {
  IconButton,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Tooltip, Typography, useTheme
} from '@mui/material';
import { PolicyRule } from '../../model/interfaces/policyRule';
import { Link as RouterLink } from 'react-router-dom';

interface RuleProps {
  rule: PolicyRule;
  onClick: (removedRule: PolicyRule) => void;
}

const RemovableListing = (props: RuleProps) => {
  const { rule, onClick } = props;
  const usePalette = useTheme().palette

  return (
    <Tooltip title={rule.description}>
      <ListItem component={Paper} sx={{backgroundColor:usePalette.secondary.main, paddingY: 0.5, borderRadius: 0.5 }}>
        <ListItemText
          secondaryTypographyProps={{
            sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
            noWrap: true
          }}
          primary={<Typography variant={'body2'}>
            <RouterLink to={`/rules/${rule.policyRuleId}`} style={{ textDecoration: 'none' }}>
              <Link underline='hover'>{rule.name}</Link>
            </RouterLink>
          </Typography>}
          secondary={<Typography variant={'caption'}> {rule.description} </Typography>}
        />
        <ListItemIcon>
          <IconButton onClick={() => onClick(rule)}>
            <CloseIcon />
          </IconButton>
        </ListItemIcon>
      </ListItem>
    </Tooltip>
  );
};

export default RemovableListing;
